import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from '../services/home.service';
import { NgToastService } from 'ng-angular-popup';
import { NgxSpinnerService } from 'ngx-spinner';

interface GoldCoin {
  id: number;
  weight: number;
  price: number;
  makingCharge: number;
  quantity: number;
}

@Component({
  selector: 'app-gold-coins',
  templateUrl: './gold-coins.component.html',
  styleUrls: ['./gold-coins.component.scss']
})
export class GoldCoinsComponent implements OnInit, OnDestroy {
  newResCoin: any;
  newLocskedPrice: any;
  showReview: boolean = false;
  metalType: any;

  constructor(
    private router: Router,
    private homeService: HomeService,
    private toast: NgToastService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
  ) {}

  minimumWeight = 100;

  goldRate = 9537.65;

  currentWeight = 0;

  remainingWeight = 100;

  progressPercentage = 0;

  makingChargeTotal = 0;

  estimatedTotal = 0;

  selectedCoins: GoldCoin[] = [];

  // ===== Price lock auto-refresh (new) =====
  priceLockTimer: number = 60;
  private priceLockInterval: any;

  ngOnInit(): void {
    const lockData = JSON.parse(localStorage.getItem('lockedPriceData') || '{}');
    console.log(lockData.lockedPrice);

    this.route.queryParams.subscribe(params => {

      this.metalType = params['metalType'] || 'Gold';
           this.fromPage = params['from'] || 'home';


      console.log('Metal Type:', this.metalType);

      this.calculateTotals();
      this.getMakingCharges();

      this.startPriceLockTimer();

    });

  }

  ngOnDestroy(): void {
    this.clearPriceLockTimer();
  }

increaseQty(coin: GoldCoin): void {
  coin.quantity++;
  this.calculateTotals();

  this.checkWeightValidation();
}
decreaseQty(coin: GoldCoin): void {
  if (coin.quantity > 0) {
    coin.quantity--;
    this.calculateTotals();

    this.checkWeightValidation();
  }
}
checkWeightValidation(): void {

  // Below minimum
  if (this.currentWeight < this.minimumWeight) {
    return;
  }

  // 100g reached and above, but not 50g multiple
  if (this.currentWeight % 50 !== 0) {

    this.toast.error({
      detail: 'ERROR',
      summary: `Please select weight in 50 g multiples. Current weight: ${this.currentWeight} g`,
      duration: 3000
    });

    return;
  }

}

  calculateTotals(): void {

    this.currentWeight = 0;
    this.makingChargeTotal = 0;
    this.estimatedTotal = 0;
    this.selectedCoins = [];

    this.newResCoin?.forEach((coin: any) => {

      if (coin.quantity > 0) {
        this.selectedCoins.push({ ...coin });
      }

      // Total Weight
      this.currentWeight += Number(coin.weight) * Number(coin.quantity);

      // Making Charges
      this.makingChargeTotal += Number(coin.making_charge) * Number(coin.quantity);

      // Gold Amount
      this.estimatedTotal += Number(coin.price) * Number(coin.quantity);

    });

    this.remainingWeight = Math.max(
      this.minimumWeight - this.currentWeight,
      0
    );

    this.progressPercentage = Math.min(
      (this.currentWeight / this.minimumWeight) * 100,
      100
    );

  }

  getGrandTotal(): number {
    return this.estimatedTotal + this.makingChargeTotal;
  }

  // continueReview(): void {

  //   if (this.currentWeight < this.minimumWeight) {
  //     return;
  //   }
  //   this.showReview = true;

  //    setTimeout(() => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: 'smooth'
  //   });
  // }, 0);


  //   // this.router.navigate(['/gold-coins-review'], {
  //   //   state: {
  //   //     coins: this.selectedCoins,
  //   //     totalWeight: this.currentWeight,
  //   //     makingCharges: this.makingChargeTotal,
  //   //     estimatedTotal: this.estimatedTotal,
  //   //     grandTotal: this.getGrandTotal()
  //   //   }
  //   // });

  // }
continueReview(): void {

  // Less than 100g
  if (this.currentWeight < this.minimumWeight) {

    this.toast.error({
      detail: 'ERROR',
      summary: `Minimum order weight is ${this.minimumWeight} g`,
      duration: 3000
    });

    return;
  }

  // 100g above but not 50g multiple
  if (this.currentWeight % 50 !== 0) {

    this.toast.error({
      detail: 'ERROR',
      summary: 'Please select weight in 50 g multiples like 100 g, 150 g, 200 g, 250 g...',
      duration: 7000
    });

    return;
  }

  // Valid weights: 100, 150, 200, 250...
  this.showReview = true;

  setTimeout(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, 0);
}
  getMakingCharges() {

    console.log('Calling API with:', this.metalType);

    const lockData = JSON.parse(localStorage.getItem('lockedPriceData') || '{}');

    const originalPrice = Number(lockData.lockedPrice || 0);

    // Gold -> per gram
    // Silver -> API returns per Kg, convert to per gram
    const lockedPrice =
      this.metalType === 'Silver'
        ? originalPrice / 1000
        : originalPrice;

    // Display current rate
    this.goldRate = lockedPrice;

    this.homeService.getMakingCharges(this.metalType).subscribe({

      next: (res: any) => {

        console.log('API Response:', res);

        this.newResCoin = (res.data || []).map((item: any) => ({
          ...item,
          weight: Number(item.coin_weight),
          quantity: 0,

          // Coin price = Rate per gram × Coin weight
          price: lockedPrice * Number(item.coin_weight)
        }));

        console.log('Mapped Coins:', this.newResCoin);

        this.calculateTotals();

      },

      error: (err: any) => {
        console.log('API Error:', err);
      }

    });

  }

  // ===== Price lock auto-refresh methods (new) =====

  startPriceLockTimer(): void {
    this.clearPriceLockTimer();
    this.priceLockTimer = 60;

    this.priceLockInterval = setInterval(() => {
      this.priceLockTimer--;

      if (this.priceLockTimer <= 0) {
        this.refreshLockedPrice();
      }
    }, 1000);
  }

  clearPriceLockTimer(): void {
    if (this.priceLockInterval) {
      clearInterval(this.priceLockInterval);
    }
  }

  refreshLockedPrice(): void {
    this.homeService.getLivePrice().subscribe({
      next: (res: any) => {

        console.log('LIVE PRICE REFRESH RESPONSE:', res);   

        // Gold: carat24.sell_price_per_gram | Silver: silverPrice.sell_price_per_gram
        const newPrice =
          this.metalType === 'Gold'
            ? res?.carat24?.sell_price_per_gram
            : res?.silverPrice?.sell_price_per_gram;

        if (newPrice) {

          const lockData = {
            type: this.metalType,
            lockedPrice: newPrice,
            timer: 60,
            lockedAt: new Date().toISOString()
          };

          localStorage.setItem('lockedPriceData', JSON.stringify(lockData));

          const lockedPrice = this.metalType === 'Silver' ? newPrice / 1000 : newPrice;
          this.goldRate = lockedPrice;

 
          this.newResCoin = (this.newResCoin || []).map((item: any) => {
            const newCoinPrice = lockedPrice * Number(item.coin_weight);
            let priceTrend = item.priceTrend || null;

            if (item.price !== undefined && item.price !== null) {
              if (newCoinPrice > item.price) {
                priceTrend = 'up';
              } else if (newCoinPrice < item.price) {
                priceTrend = 'down';
              }
     
            }

            return {
              ...item,
              price: newCoinPrice,
              priceTrend
            };
          });

          this.calculateTotals();
        }

        this.startPriceLockTimer();
      },
      error: (err) => {
        console.log('Error refreshing live price:', err);
        this.startPriceLockTimer();
      }
    });
  }

  placeOrder(): void {

    const lockData = JSON.parse(localStorage.getItem('lockedPriceData') || '{}');

    const payload = {

      metal_type: this.metalType,

      purchased_price: lockData.lockedPrice.toString(),

      items: this.selectedCoins.map((item: any) => ({
        coin_weight: item.weight,
        quantity: item.quantity
      }))

    };

    this.spinner.show();

    this.homeService.placeCoinOrder(payload).subscribe({

      next: (res: any) => {

        this.spinner.hide();

        this.toast.success({
          detail: 'SUCCESS',
          summary: res.msg,
          duration: 3000
        });

        localStorage.removeItem('lockedPriceData');

        this.router.navigate(['/orders'], {
          queryParams: {
            orderType: 'Coins',
            metalType: this.metalType,
            from: 'order'
          }
        });

      },

      error: (err: any) => {

        this.spinner.hide();

        this.toast.error({
          detail: 'ERROR',
          summary: err.error?.msg || 'Failed to place order',
          duration: 3000
        });

      }

    });

  }

  backToSelection(): void {

    this.showReview = false;

  }
isValidWeight(): boolean {
  return (
    this.currentWeight >= this.minimumWeight &&
    this.currentWeight % 50 === 0
  );
}


fromPage: string = 'home';


goBack(): void {

  if (this.fromPage === 'mobileview') {
    this.router.navigate(['/mobile/mobileview']);
  } else {
    this.router.navigate(['/home']);
  }

}
}